/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import { createApiAction } from 'api/core';

const createResetPassword = createApiAction({
  method: 'post',
  url: '/ajax/resetPassword/create',
  requestBodyMapper: ({
    emailAddress
  }) => ({
    emailAddress,
    isResend: false
  }),
  responseMapper: ({ success, response }) => {
    if (!success || !response) return {};

    const { isLocked, supportRequired } = response;

    if (isLocked) {
      return {
        result: { failure: 'Locked' }
      };
    }

    if (supportRequired) {
      return {
        result: { failure: 'SupportRequired' }
      };
    }

    return {
      result: { initiated: true }
    };
  }
});

export default createResetPassword;